export default __webpack_public_path__ + "static/pinterestp2-6b92628c7a622fdc17295099a7c02cc6.svg";